import { AuthService } from '../../services/AuthService';

export class AuthModal {
  private static overlayEl: HTMLElement | null = null;

  static show(mode: 'login' | 'register' = 'login'): void {
    this.close();

    const overlay = document.createElement('div');
    overlay.className = 'ad-interstitial-overlay';
    overlay.style.zIndex = '100000';

    overlay.innerHTML = `
      <div class="glass-panel" style="width: 90%; max-width: 420px; padding: 32px; border-radius: 20px; display: flex; flex-direction: column; gap: 20px; position: relative; background: #1e293b; border: 1px solid #334155;">
        <button id="close-auth-modal" style="position: absolute; top: 16px; right: 20px; color: #94a3b8; font-size: 1.4rem;">&times;</button>
        
        <div style="text-align: center;">
          <h2 style="font-size: 1.6rem; font-weight: 800;" class="gradient-text" id="auth-title">
            ${mode === 'login' ? 'Giriş Yap' : 'Kayıt Ol'}
          </h2>
          <p style="color: #94a3b8; font-size: 0.85rem; margin-top: 6px;">Arcade Portal dünyasına katıl, skorlarını kaydet!</p>
          <div style="background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); color: #fca5a5; padding: 10px; border-radius: 8px; font-size: 0.8rem; margin-top: 12px; text-align: left;">
            <strong style="color: #ef4444;">💡 Bilgilendirme:</strong> Misafir oyuncu kayıtları (başarımlar ve skorlar), güvenlik gereği 2 gün (48 saat) içerisinde yeni üyelik açılmazsa otomatik olarak silinmektedir.
          </div>
        </div>

        <!-- Google OAuth ile Giriş Yap Butonu -->
        <button id="google-login-btn" style="width: 100%; padding: 12px; background: #ffffff; color: #1e293b; border-radius: 10px; font-weight: 700; font-size: 0.92rem; display: flex; align-items: center; justify-content: center; gap: 10px; box-shadow: 0 4px 12px rgba(255,255,255,0.15); transition: transform 0.15s ease;">
          <span style="font-size: 1.2rem;">🌐</span>
          <span>Google Hesabı ile Giriş Yap</span>
        </button>

        <div style="display: flex; align-items: center; gap: 10px; margin: 4px 0;">
          <div style="flex: 1; height: 1px; background: #334155;"></div>
          <span style="color: #64748b; font-size: 0.75rem; font-weight: 700; text-transform: uppercase;">veya E-Posta</span>
          <div style="flex: 1; height: 1px; background: #334155;"></div>
        </div>

        <form id="auth-form" style="display: flex; flex-direction: column; gap: 14px;">
          ${
            mode === 'register'
              ? `
            <div>
              <label style="font-size: 0.8rem; color: #94a3b8; font-weight: 600;">KULLANICI ADI</label>
              <input type="text" id="auth-username" required placeholder="ör: PixelMaster" style="width: 100%; padding: 10px 14px; background: #0f172a; border: 1px solid #334155; border-radius: 8px; color: #fff; margin-top: 4px; outline: none;">
            </div>
          `
              : ''
          }
          <div>
            <label style="font-size: 0.8rem; color: #94a3b8; font-weight: 600;">E-POSTA ADRESİ</label>
            <input type="email" id="auth-email" required placeholder="ornek@email.com" style="width: 100%; padding: 10px 14px; background: #0f172a; border: 1px solid #334155; border-radius: 8px; color: #fff; margin-top: 4px; outline: none;">
          </div>
          <div>
            <label style="font-size: 0.8rem; color: #94a3b8; font-weight: 600;">ŞİFRE</label>
            <input type="password" id="auth-password" required placeholder="••••••••" style="width: 100%; padding: 10px 14px; background: #0f172a; border: 1px solid #334155; border-radius: 8px; color: #fff; margin-top: 4px; outline: none;">
          </div>

          <button type="submit" style="width: 100%; padding: 12px; background: linear-gradient(135deg, #6366f1, #a855f7); color: #fff; border-radius: 8px; font-weight: 700; font-size: 0.95rem; margin-top: 4px; box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);">
            ${mode === 'login' ? 'Giriş Yap' : 'Hesabımı Oluştur'}
          </button>
        </form>

        <div style="text-align: center; font-size: 0.85rem; color: #94a3b8;">
          ${
            mode === 'login'
              ? `Hesabın yok mu? <a href="javascript:void(0)" id="switch-to-reg" style="color: #818cf8; font-weight: 700;">Hemen Kayıt Ol</a>`
              : `Zaten hesabın var mı? <a href="javascript:void(0)" id="switch-to-login" style="color: #818cf8; font-weight: 700;">Giriş Yap</a>`
          }
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    this.overlayEl = overlay;

    overlay.querySelector('#close-auth-modal')?.addEventListener('click', () => this.close());
    overlay.querySelector('#switch-to-reg')?.addEventListener('click', () => this.show('register'));
    overlay.querySelector('#switch-to-login')?.addEventListener('click', () => this.show('login'));

    overlay.querySelector('#google-login-btn')?.addEventListener('click', async () => {
      await AuthService.loginWithGoogle();
      this.close();
    });

    overlay.querySelector('#auth-form')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = (overlay.querySelector('#auth-email') as HTMLInputElement).value;
      const pass = (overlay.querySelector('#auth-password') as HTMLInputElement).value;
      const usernameInput = overlay.querySelector('#auth-username') as HTMLInputElement;
      const username = usernameInput ? usernameInput.value : email.split('@')[0];

      let success = false;
      if (mode === 'register') {
        success = await AuthService.register(email, pass, username);
      } else {
        success = await AuthService.login(email, pass);
      }

      if (success) {
        this.close();
      }
    });
  }

  static close(): void {
    if (this.overlayEl) {
      this.overlayEl.remove();
      this.overlayEl = null;
    }
  }
}
